import { Injectable } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { FeatureToggleService } from '../../core/services/feature-toggle.service';
import { Store } from '@ngxs/store';
import { StatusPreautorisation, preautStatusWithDashboardContent } from '../../shared/modeles/variables';
import { CardModele } from '../modeles/cardModele';
import { SectionModele } from '../modeles/sectionModele';
import { ProprieteState } from '../../propriete/propriete.state';
import {
  MPM_ACTEVENTE_VISIBILITY,
  MPM_CAPACITE_VERSION,
  MPM_EMMENAGEMENT_VISIBILITY,
  MPM_OCTROI_VISIBILITY,
  MPM_OFFREACHAT_VISIBILITY,
  MPM_PREAUT_VERSION,
  MPM_PROPRIETE_VISIBILITY,
  MPM_ASSURANCEPRET_VISIBILITY,
  MPM_ASSURANCEHABITATION_VISIBILITY
} from '../../../configs/toggles.config';
import { FeatureToggleModele } from '../../core/modeles/feature-toggle.modele';
import { ToolCapaciteService } from '../../tool-capacite/tool-capacite.service';
import { ToolPreautorisationService } from '../../tool-preautorisation/tool-preautorisation.service';
import { CheminAbsoluStatiquePipe } from '../../shared/pipes/chemin-absolu-statique.pipe';

@Injectable()
export class ContentCardService {
  cards: Array<CardModele> = [
    {
      titre: 'dashboard.card-un.titre',
      urlIcone: this.getCheminAbsoluStatique('assets/images/icon-page/icon-capacite.svg'),
      contentCard: [
        {
          sousTitre: null,
          texte: 'dashboard.card-un.un.content-card.texte',
          texteBtn: 'dashboard.card-un.un.content-card.texte-bouton',
          lienBtn: '/capacite',
          idTestAuto: 'btn-calculer-capacite',
          typeEtape: 'capacite',
          extraClass: '',
          isActive: !this.isActive(MPM_CAPACITE_VERSION.Disabled)
        }
      ],
      isFullWidth: this._toolCapaciteService.isCapacityCompleted$,
      isActive: !this.isActive(MPM_CAPACITE_VERSION.Disabled)
    },
    {
      titre: 'dashboard.card-deux.titre',
      urlIcone: this.getCheminAbsoluStatique('assets/images/icon-page/icon-propriete.svg'),
      contentCard: [
        {
          sousTitre: null,
          texte: 'dashboard.card-deux.un.content-card.texte',
          texteBtn: 'dashboard.card-deux.un.content-card.texte-bouton',
          lienBtn: '/propriete/creation-propriete',
          idTestAuto: 'btn-ajouter-propriete',
          typeEtape: 'ajouter-propriete',
          extraClass: '',
          isActive: this.isActive(MPM_PROPRIETE_VISIBILITY.On)
        }
      ],
      isFullWidth: this._store.select(ProprieteState.isProprietesCreated),
      isActive: this.isActive(MPM_PROPRIETE_VISIBILITY.On)
    },
    {
      titre: 'dashboard.card-trois.titre',
      urlIcone: this.getCheminAbsoluStatique('assets/images/icon-page/icon-preaut.svg'),
      contentCard: [
        {
          sousTitre: null,
          texte: 'dashboard.card-trois.un.content-card.texte',
          texteBtn: 'dashboard.card-trois.un.content-card.texte-bouton',
          lienBtn: '/preautorisation-simplifiee',
          idTestAuto: 'btn-avantages-preautorisation',
          typeEtape: 'avantages-preautorisation',
          extraClass: '',
          isActive: !this.isActive(MPM_PREAUT_VERSION.Disabled)
        }
      ],
      isFullWidth: of(true),
      isActive: !this.isActive(MPM_PREAUT_VERSION.Disabled)
    },
    {
      titre: 'dashboard.card-quatre.titre',
      urlIcone: this.getCheminAbsoluStatique('assets/images/icon-page/icon-offre.svg'),
      contentCard: [
        {
          sousTitre: null,
          texte: 'dashboard.card-quatre.un.content-card.texte',
          texteBtn: 'dashboard.card-quatre.un.content-card.texte-bouton',
          lienBtn: '/offre-achat',
          idTestAuto: 'btn-offre-achat',
          typeEtape: 'offre-achat',
          extraClass: '',
          isActive: this.isActive(MPM_OFFREACHAT_VISIBILITY.On)
        }
      ],
      isFullWidth: of(true),
      isActive: this.isActive(MPM_OFFREACHAT_VISIBILITY.On)
    },
    {
      titre: 'dashboard.card-cinq.titre',
      urlIcone: this.getCheminAbsoluStatique('assets/images/icon-page/icon-assurance.svg'),
      contentCard: [
        {
          sousTitre: 'dashboard.card-cinq.un.content-card.sous-titre',
          texte: 'dashboard.card-cinq.un.content-card.texte',
          texteBtn: 'dashboard.card-cinq.un.content-card.texte-bouton',
          lienBtn: '/octroi',
          idTestAuto: 'btn-mon-pret',
          typeEtape: 'octroi',
          extraClass: '',
          isActive: this.isActive(MPM_OCTROI_VISIBILITY.On)
        },
        {
          sousTitre: 'dashboard.card-cinq.deux.content-card.sous-titre',
          texte: 'dashboard.card-cinq.deux.content-card.texte',
          texteBtn: 'dashboard.card-cinq.deux.content-card.texte-bouton',
          lienBtn: '/assurance-pret',
          idTestAuto: 'btn-assurances-pret',
          typeEtape: 'assurances-pret',
          extraClass: 'small-block',
          isActive: this.isActive(MPM_ASSURANCEPRET_VISIBILITY.On)
        },
        {
          sousTitre: 'dashboard.card-cinq.trois.content-card.sous-titre',
          texte: 'dashboard.card-cinq.trois.content-card.texte',
          texteBtn: 'dashboard.card-cinq.trois.content-card.texte-bouton',
          lienBtn: '/assurance-habitation',
          idTestAuto: 'btn-assurances-habitation',
          typeEtape: 'assurances-habitation',
          extraClass: 'small-block',
          isActive: this.isActive(MPM_ASSURANCEHABITATION_VISIBILITY.On)
        }
      ],
      isFullWidth: of(true),
      isActive:
        this.isActive(MPM_OCTROI_VISIBILITY.On) ||
        this.isActive(MPM_ASSURANCEPRET_VISIBILITY.On) ||
        this.isActive(MPM_ASSURANCEHABITATION_VISIBILITY.On)
    },
    {
      titre: 'dashboard.card-six.titre',
      urlIcone: this.getCheminAbsoluStatique('assets/images/icon-page/icon-acte-vente.svg'),
      contentCard: [
        {
          sousTitre: null,
          texte: 'dashboard.card-six.un.content-card.texte',
          texteBtn: 'dashboard.card-six.un.content-card.texte-bouton',
          lienBtn: '/acte-vente',
          idTestAuto: 'btn-acte-vente',
          typeEtape: 'acte-vente',
          extraClass: '',
          isActive: this.isActive(MPM_ACTEVENTE_VISIBILITY.On)
        }
      ],
      isFullWidth: of(false),
      isActive: this.isActive(MPM_ACTEVENTE_VISIBILITY.On)
    },
    {
      titre: 'dashboard.card-sept.titre',
      urlIcone: this.getCheminAbsoluStatique('assets/images/icon-page/icon-demenagement.svg'),
      contentCard: [
        {
          sousTitre: null,
          texte: 'dashboard.card-sept.un.content-card.texte',
          texteBtn: 'dashboard.card-sept.un.content-card.texte-bouton',
          lienBtn: '/emmenagement',
          idTestAuto: 'btn-emmenagement',
          typeEtape: 'emmenagement',
          extraClass: '',
          isActive: this.isActive(MPM_EMMENAGEMENT_VISIBILITY.On)
        }
      ],
      isFullWidth: of(false),
      isActive: this.isActive(MPM_EMMENAGEMENT_VISIBILITY.On)
    }
  ];

  sections: Array<SectionModele> = [
    { titre: 'dashboard.sections.me-preparer', cards: this.cards.slice(0, 3) },
    { titre: 'dashboard.sections.financer-ma-maison', cards: this.cards.slice(3, 5) },
    { titre: 'dashboard.sections.concretiser-mon-projet', cards: this.cards.slice(5, 7) }
  ];

  data = new BehaviorSubject<Array<SectionModele>>(this.sections);
  dataChanged$ = this.data.asObservable();
  status: StatusPreautorisation;

  constructor(
    private readonly _featureToggleService: FeatureToggleService,
    private readonly _store: Store,
    private readonly _toolPreautorisationService: ToolPreautorisationService,
    private readonly _toolCapaciteService: ToolCapaciteService,
    private readonly _cheminAbsoluStatiquePipe: CheminAbsoluStatiquePipe
  ) {
    this._toolPreautorisationService.getStatusPreautorisation$.subscribe(status => (this.status = status));
  }

  isActive(feature: FeatureToggleModele): boolean {
    return this._featureToggleService.hasFeatures(feature);
  }

  isPreautStatusShown(): boolean {
    return preautStatusWithDashboardContent.includes(this.status);
  }

  private getCheminAbsoluStatique(imagePath: string) {
    return this._cheminAbsoluStatiquePipe.transform(imagePath);
  }
}
